import React from 'react'

// Custom Components
import Layout from '../components/layout/Layout'
import PortfolioList from '../components/portfolios/portfolio_list/PortfolioList';

// React Helmet
import { Helmet } from 'react-helmet';

import { Button } from 'react-bootstrap';

import { Link } from 'react-router';
import NewsletterForm from '../components/newsletter/NewsletterForm';

export default function Portfolios() {
  <Helmet>
    <title>Beginner Investment Portfolios | Stocks With Nik</title>

    <meta
      name="description"
      content="Browse simple, beginner-friendly investment portfolios designed for long-term growth and stability. Each portfolio includes ETFs, dividend options, and easy-to-follow explanations."
    />

    <meta
      name="keywords"
      content="beginner portfolios, investment portfolios, ETF portfolios, dividend portfolios, simple investing, long term investing portfolios"
    />

    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Helmet>


  return (
    <>
      <Layout content={
        <>
          <div className='p-2 mb-5 mt-5' style={{ textAlign: "center" }}>
            <h1>Beginner Portfolio Examples</h1>
            <p>These are sample portfolios designed for different types of investors.
              They’re meant to educate — not tell you exactly what to buy.
              <br />
              If you want something tailored to your goals and risk tolerance, take the quiz to generate your own personalized plan.</p>
          </div>
          <PortfolioList />
          <div className='p-2 mb-2 mt-5' style={{ textAlign: "center", maxWidth: "850px", margin: "auto auto" }}>
            <h3>Not Sure Which Portfolio Fits You?</h3>
            <p>These are sample portfolios designed for different types of beginner investors.
              But investing isn’t one-size-fits-all.

              Your age, goals, risk tolerance, income stability, and even how you react during market drops all matter.

              Instead of guessing, you can build a personalized portfolio in just a few minutes.</p>
            <Link to='/quiz'><Button>Build My Portfolio</Button></Link>
          </div>
          <NewsletterForm />
        </>
      } />
    </>
  )
}
